import React, { useMemo } from "react";
import { useBoltDocumentTemplateForm } from "./useBoltDocumentTemplateForm";
import { ActionButtons, FileField, Footer, TextField } from "@ucl/library";
import { useBoltApiClient } from "@bolt/core";

export interface BoltDocumentTemplateFormProps {
  onSave?: () => void;
  onCancel?: () => void;
}

export const BoltDocumentTemplateForm: React.FC<
  BoltDocumentTemplateFormProps
> = (props) => {
  const boltApiClient = useBoltApiClient();

  const {
    createTemplate,
    textFieldProps,
    fileFieldProps,
    isSaving,
    templateName,
    templateFile,
  } = useBoltDocumentTemplateForm(props, boltApiClient);

  // Memoize the components
  const TemplateFileField = useMemo(() => React.memo(FileField), []);

  return (
    <section className="bolt-document-template-form">
      {boltApiClient && (
        <div className="bolt-document-template-form-content">
          <TextField {...textFieldProps} />
          <TemplateFileField {...fileFieldProps} />
        </div>
      )}
      <Footer>
        <ActionButtons
          data={{
            templateName,
            templateFile,
          }}
          actions={[
            {
              text: "Cancel",
              onActionClick: props.onCancel,
            },
            {
              text: "Save",
              isPrimary: true,
              isDisabled: (data) => !data?.templateFile || !data?.templateName,
              isLoading: isSaving,
              onActionClick: () => {
                createTemplate();
              },
            },
          ]}
        />
      </Footer>
    </section>
  );
};
